module.exports = __webpack_public_path__ + "img/1557614075789254659.5c431cc2.png";